import styled from 'styled-components'

import { X } from 'react-feather'

export const StyledClose = styled(X)`
  :hover {
    cursor: pointer;
  }
`

export default function URLWarning() {
  return null
}
